// src/pages/markets/board/board/useMouseHover.ts
//
// Whether a hovering pointer is over an element, for holding a list still under
// the cursor. Pointer events, and every kind but touch: a mouse hovers, and so
// does a pen above the screen (Surface, Wacom, Apple Pencil), but a finger does
// not. A tap fires compatibility mouse events after it, a mouseenter with no
// mouseleave until something else is tapped, so mouse events would read a tap
// as a pointer that never leaves.

import { useMemo, useState, type PointerEvent } from 'react';

export function useMouseHover() {
    const [hovered, setHovered] = useState(false);
    const handlers = useMemo(
        () => ({
            onPointerEnter: (event: PointerEvent) => {
                if (event.pointerType !== 'touch') setHovered(true);
            },
            onPointerLeave: () => setHovered(false),
        }),
        []
    );
    return { hovered, handlers };
}
